<template>
  <Details search />
</template>

<script>
import Details from "../Patients/details.vue";
export default {
  components: {
    Details
  }
};
</script>

<style></style>
